/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
          <ul>
              <li>
                <a href="http://192.241.155.223/" target="_blank" className="text-capitalize">
                Benin SVDL
                </a>
              </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          © {new Date().getFullYear()},{" "}
          <a
          // href=""
          // target="_blank"
          >
            Supported by GHSC-TA Francophone TO, Benin |  v{localStorage.getItem("sw_Version")} - {process.env.REACT_APP_VERSION_APP} 
          </a>
        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
